import type { ModalProps } from "antd";

import {
  compactBodyClassName,
  compactFooterClassName,
  compactHeaderClassName,
  defaultBodyClassName,
  defaultFooterClassName,
  defaultHeaderClassName,
  fullScreenBodyClassName,
  fullScreenContainerClassName,
  fullScreenFooterClassName,
  fullScreenHeaderClassName
} from "./styles";

export type Layout = "default" | "compact" | "fullScreen";

export const MODAL_FOOTER_CLASS_NAMES: Record<Layout, string> = {
  compact: compactFooterClassName,
  default: defaultFooterClassName,
  fullScreen: fullScreenFooterClassName
};

export const MODAL_LAYOUT_CLASS_NAMES: Record<Layout, ModalProps["classNames"]> = {
  compact: {
    body: compactBodyClassName,
    footer: compactFooterClassName,
    header: compactHeaderClassName
  },
  default: {
    body: defaultBodyClassName,
    footer: defaultFooterClassName,
    header: defaultHeaderClassName
  },
  fullScreen: {
    body: fullScreenBodyClassName,
    container: fullScreenContainerClassName,
    footer: fullScreenFooterClassName,
    header: fullScreenHeaderClassName
  }
};
